export const SITE_URL = "https://ghinashop.net";
export const SITE_NAME = "Ghina Shop";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/ahmad%20hasoun%202%201.png`;

export const SEO = {
  ar: {
    home: {
      title: "غينا شوب | تسوق أونلاين في سوريا",
      description:
        "غينا شوب - متجر إلكتروني سوري لبيع المنتجات بأفضل الأسعار. تسوق أونلاين، تصفّح الفئات، واطلب توصيلاً لباب منزلك.",
      keywords:
        "غينا شوب, متجر إلكتروني, تسوق أونلاين, سوريا, منتجات, أفضل الأسعار",
    },
    categories: {
      title: "الفئات",
      description: "تصفّح جميع فئات المنتجات في غينا شوب واختر ما يناسبك.",
    },
    seller: {
      title: "المتاجر",
      description: "اكتشف المتاجر والبائعين المعتمدين في غينا شوب.",
    },
    products: {
      title: "المنتجات",
      description: "تصفّح مجموعة واسعة من المنتجات في غينا شوب بأفضل الأسعار.",
    },
    login: {
      title: "تسجيل الدخول",
      description: "سجّل دخولك إلى حسابك في غينا شوب.",
      noIndex: true,
    },
    signup: {
      title: "إنشاء حساب",
      description: "أنشئ حساباً جديداً في غينا شوب.",
      noIndex: true,
    },
    private: {
      title: "غينا شوب",
      description: "غينا شوب - متجر إلكتروني سوري.",
      noIndex: true,
    },
  },
  en: {
    home: {
      title: "Ghina Shop | Online Shopping in Syria",
      description:
        "Ghina Shop - Syrian online store with the best prices. Browse categories, shop online, and get delivery to your door.",
      keywords:
        "Ghina Shop, online store, e-commerce, Syria, products, best prices",
    },
    categories: {
      title: "Categories",
      description: "Browse all product categories at Ghina Shop.",
    },
    seller: {
      title: "Stores",
      description: "Discover trusted stores and sellers on Ghina Shop.",
    },
    products: {
      title: "Products",
      description: "Browse a wide range of products at Ghina Shop at the best prices.",
    },
    login: {
      title: "Login",
      description: "Sign in to your Ghina Shop account.",
      noIndex: true,
    },
    signup: {
      title: "Sign Up",
      description: "Create a new Ghina Shop account.",
      noIndex: true,
    },
    private: {
      title: "Ghina Shop",
      description: "Ghina Shop - Syrian online store.",
      noIndex: true,
    },
  },
};

const PRIVATE_PATHS = new Set([
  "/login",
  "/signup",
  "/forget-password",
  "/otp-verification",
  "/my-cart",
  "/my-orders",
  "/wishlist-page",
  "/account",
]);

export const getRouteSEO = (pathname, lang) => {
  const locale = lang === "ar" ? "ar" : "en";
  const t = SEO[locale];

  if (pathname.startsWith("/product-details/")) {
    return null;
  }

  if (PRIVATE_PATHS.has(pathname)) {
    if (pathname === "/login") return t.login;
    if (pathname === "/signup") return t.signup;
    return t.private;
  }

  if (pathname === "/") return t.home;
  if (pathname === "/categories") return t.categories;
  if (pathname === "/seller") return t.seller;
  if (pathname.startsWith("/products/")) return t.products;

  return t.home;
};
